import { Flex, Spin } from "@p0security/ui";
import * as React from "react";

import { Splash } from "../Splash";

const Loader: React.FC = () => {
  return (
    <Splash>
      <Flex align="center" justify="center">
        <Spin />
      </Flex>
    </Splash>
  );
};

export default Loader;
